import React from 'react';
import Dashboard from '../Dashboard';
import FarmsOverview from '../../components/FarmsOverview';
import useAuthContext from '../../hooks/useAuthContext';
import { hasPermission } from '../../utils/permissionUtils';
import { Permission } from '../../constants/permissions';

/**
 * `/dashboard` - what a user lands on after signing in.
 *
 * One screen per role, decided by the farms-overview permission: a farm user gets the dashboard for their
 * own farm, an admin gets the estate-wide queue, which is the job they signed in for. There is no switch
 * between the two - an admin reads a single farm by opening it from the queue, and `/dashboard/:farmId`
 * renders the same dashboard against that farm, their own included.
 */
const DashboardHome: React.FC = () => {
  const { state } = useAuthContext();

  const canSeeOverview = hasPermission(state.role, Permission.VIEW_FARMS_OVERVIEW);

  return canSeeOverview ? <FarmsOverview /> : <Dashboard />;
};

export default DashboardHome;
